import { renderUtils } from '../render/render.js';
import { AttributeUtils } from '../attribute/attribute.js';

export class EDSComponent extends HTMLElement {
  /**
   * @static
   */
  static componentName = '';

  /**
   * @static
   * @returns {string}
   */
  static tagName() {
    return `e-${this.componentName}`;
  }

  refs = {};
  test = { refs: {} };

  constructor(params) {
    const element = super(params);

    if (this.constructor.componentName === '') {
      throw new Error('The componentName static property must be defined!');
    }

    const renderFn = element.render || element._render || (() => {});

    element.requestRender = renderUtils.debounce.create((...args) => {
      renderFn.call(this, ...args);
    }, this);
    element.init();
    return element;
  }

  init() {}

  /**
   * @param name
   * @param oldValue
   * @param newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    const transformedName = name.replace(/-([a-z])/g, g => g[1].toUpperCase());
    this[transformedName] = newValue;
  }

  /**
   * @param name
   * @param value
   */
  reflectStringAttribute(name, value) {
    if (value === null && this.hasAttribute(name)) {
      this.removeAttribute(name);
    } else if (this.getAttribute(name) !== value) {
      this.setAttribute(name, value);
    }
  }

  reflectBooleanAttribute(name, value) {
    const attributeValue = AttributeUtils.convertToBoolean(value);

    if (attributeValue === false && this.hasAttribute(name)) {
      this.removeAttribute(name);
    } else if (attributeValue === true && !this.hasAttribute(name)) {
      this.setAttribute(name, '');
    }
  }

  createReference(path, options = { testOnly: false }) {
    const targets = [
      ...(!options.testOnly ? [this.refs] : []),
      ...(window?.e?.testMode ? [this.test.refs] : [])
    ];

    return (node) => {
      if (window?.e?.testMode) {
        node.dataset.testid = `${this.constructor.componentName}.${path.join('.')}`;
      }

      targets.forEach((target) => this.#setPropertyByPath(target, path, node));
    };
  }

  #setPropertyByPath (object, path, value) {
    let currentProperty = object;

    for (const [index, property] of path.entries()) {
      const isPropertyLast = index === path.length - 1;

      if (isPropertyLast) {
        currentProperty[property] = value;
        return;
      }

      const nextProperty = path[index + 1];
      const isNextPropertyValidIndex = Number.isInteger(nextProperty) && nextProperty >= 0;
      const defaultValueForProperty = (isNextPropertyValidIndex ? [] : {});
      const isCurrentPropertyValid = typeof currentProperty[property] === 'object' && currentProperty[property] !== null;

      currentProperty[property] = isCurrentPropertyValid ? currentProperty[property] : defaultValueForProperty;
      currentProperty = currentProperty[property];
    }
  }

  _cleanupContainer(containerSelector) {
    const container = this.querySelector(containerSelector);
    if (container) {
      this.removeChild(container);
    }
  }
}
